import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-tag',
	templateUrl:'./WaTagPage.html',
	styles: [],
	styleUrls:['./WaTagPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaTagPage
{
	mdContent_469 = `\`\`\`java
import com.jwebmp.webawesome.components.tag.WaTag;
\`\`\``;
	mdContent_470 = `\`\`\`java
var tag = new WaTag<>();
tag.setVariant(Variant.Brand);
tag.setPill(true);
tag.setRemovable(true);
tag.setText("Angular");
\`\`\``;
}
